import * as Types from '../../../../graphql-types'

import { gql } from '@apollo/client'
import { ContentFeatureMediaFragmentFragmentDoc } from '../../../../services/yi/queries/ContentFeatureMediaFragment.generated'
import { ContentDetails_Tag_ContentReferenceFragmentFragmentDoc } from '../../../../services/yi/queries/ContentDetailsTagContentReferenceFragment.generated'
import { Content_ProviderCommonFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderCommonFragment.generated'
import { Content_ProviderMetadataFragmentFragmentDoc } from '../../../../services/yi/queries/ContentProviderMetadataFragment.generated'
export type YiMemberPromo_ContentFragmentFragment = {
  __typename?: 'Content'
  contentPolicyPolicyId?: number | null
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  language?: string | null
  description?: string | null
  descriptionFormat?: string | null
  path?: string | null
  primaryLanguage?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  title?: string | null
  featureMediaId?: string | null
  yiContentType?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    sortKey?: number | null
    contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      titleGroupId?: string | null
      title?: string | null
      contentId?: number | null
      contentType?: string | null
      published?: boolean | null
      yiTagGroup?: Array<{
        __typename?: 'ContentReference'
        contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
      } | null> | null
    } | null> | null
  } | null> | null
  yiGiveAwayCourses?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      title?: string | null
      published?: boolean | null
    } | null> | null
  } | null> | null
  yiPromotedContent?: Array<{
    __typename?: 'ContentReference'
    id?: string | null
    contentTo?: Array<{
      __typename?: 'Content'
      id?: string | null
      contentType?: string | null
      contentId?: number | null
      title?: string | null
      published?: boolean | null
      contentProvider?: {
        __typename?: 'ContentProvider'
        provider?: Types.ContentProviderProviders | null
        providerKey?: string | null
        contentId?: string | null
      } | null
      yiContentType?: Array<{
        __typename?: 'ContentReference'
        id?: string | null
        sortKey?: number | null
        contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
        contentTo?: Array<{
          __typename?: 'Content'
          id?: string | null
          titleGroupId?: string | null
          title?: string | null
          contentId?: number | null
          contentType?: string | null
          published?: boolean | null
          yiTagGroup?: Array<{
            __typename?: 'ContentReference'
            contentTo?: Array<{ __typename?: 'Content'; title?: string | null } | null> | null
          } | null> | null
        } | null> | null
      } | null> | null
    } | null> | null
  } | null> | null
  featureMedia?: {
    __typename?: 'Media'
    mediaId?: string | null
    contentId?: string | null
    mediaMaestroTitleCode?: string | null
    policyId?: number | null
    updatedAt?: any | null
    duration?: number | null
    isPublished?: boolean | null
    mediaAssets?: Array<{
      __typename?: 'MediaAsset'
      id?: string | null
      providerKey?: string | null
    } | null> | null
  } | null
  providerMetadata?: {
    __typename?: 'ContentProvider'
    metadata?: any | null
    contentId?: string | null
  } | null
}

export const YiMemberPromo_ContentFragmentFragmentDoc = gql`
  fragment YIMemberPromo_ContentFragment on Content {
    contentPolicyPolicyId
    id
    contentId
    contentType
    language
    description
    descriptionFormat
    path
    primaryLanguage
    published
    publishedAtDate
    title
    ...ContentFeatureMediaFragment
    yiContentType: contentReferencesFrom(types: "yi-content-type") {
      ...ContentDetails_Tag_ContentReferenceFragment
    }
    yiGiveAwayCourses: contentReferencesFrom(types: "yi-course") {
      id
      contentTo {
        id
        contentType
        contentId
        title
        published
      }
    }
    yiPromotedContent: contentReferencesFrom(types: "yi-promoted-content") {
      id
      contentTo {
        id
        contentType
        contentId
        title
        published
        contentProvider {
          provider
          providerKey
          ...Content_ProviderCommonFragment
        }
        yiContentType: contentReferencesFrom(types: "yi-content-type") {
          ...ContentDetails_Tag_ContentReferenceFragment
        }
      }
    }
    ...Content_ProviderMetadataFragment
  }
  ${ContentFeatureMediaFragmentFragmentDoc}
  ${ContentDetails_Tag_ContentReferenceFragmentFragmentDoc}
  ${Content_ProviderCommonFragmentFragmentDoc}
  ${Content_ProviderMetadataFragmentFragmentDoc}
`
